import styled from "styled-components"

export const CardLabels = styled.div `

    width: 100%;
    height: fit-content;
    display: grid;

`